module.exports = __webpack_public_path__ + "static/media/Goblin-Unselected.1e46fbe0.png";